<template>
  <div id="app">
    <!-- <Header v-show="$route.path!='/login'"/> -->
    <Header v-show="$route.meta.isShowHeader"/>
    <Banner  v-show="$route.meta.isShowBannner"/>
    <router-view></router-view>
    <Footer/>
    
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'
import Banner from './components/Banner'
import { post } from '@/units/request.js'
export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Banner
  },
  methods: {
	//获取当前活动信息
	async getActiveInfo(){
		let url = 'v1/activity/getIndexActivity'
		let param = {}
		const res = await post(url, param)
		if(res.data.code==200) {
			let entity = res.data.entity
			localStorage.setItem('activityId', entity.id)
			localStorage.setItem('activityType', entity.activityType)
			localStorage.setItem('activeInfo', JSON.stringify(entity))
		} else {
			this.$message.error(res.data.msg)
		}
	},
  },
  created(){
	//活动切换的时候及时更新活动id
	this.getActiveInfo()
  }
}
</script>

<style>

</style>
